import React, {useContext, useEffect, useState, useRef, useCallback} from 'react'
import {
  IconButton,
  Popover,
  Checkbox,
  Typography,
  TextField,
  Grid,
  CircularProgress,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationContext} from './../../../context/Reservation'
import SearchIcon from '@material-ui/icons/Search'
import Button from '@material-ui/core/Button'
import {normalizeFieldValues} from './util'
import InputAdornment from '@material-ui/core/InputAdornment'
import CloseIcon from '@material-ui/icons/Close'
import CheckIcon from '@material-ui/icons/Check'
import './FilterFieldItemsList.scss'
export default function FilterFieldItemsList({
  options,
  handleClickValueOption,
  value,
  values,
  field,
  objects,
  setSelectedFilters,
}) {
  const {loadFilterFieldValues, filterFieldValues} = useContext(ReservationContext)
  const [isSearching, setSearching] = useState(false)
  const [normalizedValues, setNormalizedValues] = useState([])
  const [selectableValues, setSelectableValues] = useState([])
  const [selectedValues, setSelectedValues] = useState([])
  const [search, setSearch] = useState('')
  const refFieldValuesScroll = useRef(null)
  const [realSearch, setRealSearch] = useState('')
  const [stillLoading, setStillLoading] = useState(true)
  const refSearch = useRef(null)

  useEffect(() => {
    if (field.field_id || field.id) {
      loadFilterFieldValues(field.field_id || field.id, realSearch, {limit: 50, page: 1})
    }
    const el = refFieldValuesScroll.current
    if (el) {
      el.scrollTop = 0
    }
  }, [field, realSearch, loadFilterFieldValues])

  useEffect(() => {
    if (values.length) {
      let exists = false
      values.map(o => {
        if (o.id === (field.field_id || field.id)) {
          exists = true
          setSelectedValues([...o.value])
        }
        return true
      })
      if (!exists) {
        setSelectedValues([])
      }
    } else {
      setSelectedValues([])
    }
  }, [values, field])

  useEffect(() => {
    const el = refFieldValuesScroll.current
    const handleScrollEvent = e => {
      if (
        Math.round(e.target.offsetHeight + e.target.scrollTop) >= Math.round(e.target.scrollHeight)
      ) {
        if (
          !filterFieldValues.isLoading &&
          filterFieldValues?.data.page < filterFieldValues?.data.total_objects / 50
        ) {
          loadFilterFieldValues(field.field_id || field.id, realSearch, {
            page: filterFieldValues?.data.page + 1,
            limit: 50,
          })
        }
      }
    }
    if (el) {
      el.addEventListener('scroll', handleScrollEvent)
    }
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScrollEvent)
      }
    }
  }, [
    refFieldValuesScroll,
    filterFieldValues,
    loadFilterFieldValues,
    realSearch,
    field.field_id,
    field.id,
  ])

  useEffect(() => {
    let _selectableValues = []

    let normalizedValues = normalizeFieldValues(
      filterFieldValues.data.field_type,
      filterFieldValues.data.values
    )
    setNormalizedValues([
      {label: 'Select All ', value: 'select_all'},
      {label: 'No Value', value: 'no_value'},
      ...normalizedValues,
    ])

    let tNormalizedValues = [
      {label: 'Select All ', value: 'select_all'},
      {label: 'No Value', value: 'no_value'},
      ...normalizedValues,
    ]
    tNormalizedValues.map(f => {
      if (!selectedValues.includes(f.value)) {
        _selectableValues.push(f)
      }
      return true
    })
    setSelectableValues([..._selectableValues])
  }, [selectedValues, filterFieldValues])

  const tryCallApi = useCallback(() => {
    setStillLoading(false)
    // eslint-disable-next-line
  }, [realSearch])

  const handleSearchText = e => {
    e.preventDefault()
    setSearch(e.target.value)
    if (e.target.value === '') {
      setRealSearch('')
    }
  }

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setRealSearch(search)
    } else {
      setSearching(true)
    }
  }

  const onCloseSearch = () => {
    refSearch.current.focus()
    setSearch('')
    setRealSearch('')
    setSearching(true)
  }

  return (
    <>
      <div
        ref={refFieldValuesScroll}
        className="c-res-mod ap-list ap-scrollbar"
        style={{maxHeight: 200, padding: '17px', width: '200px'}}
      >
        <Grid container style={{position: 'relative'}} xs={12}>
          {isSearching ? (
            <Grid item xs={10} className="search-option-body-gantt-filter-items">
              <TextField
                onBlur={() => {
                  isSearching === true && search === '' ? setSearching(false) : setSearching(true)
                }}
                id="standard-basic"
                type="text"
                className="c-res-mod ap-list ap-scrollbar"
                autoFocus
                value={search}
                onChange={handleSearchText}
                onKeyDown={e => handleSearch(e)}
                inputRef={refSearch}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div isDisabled={true}>
                        <CloseIcon style={{cursor: 'pointer'}} onClick={onCloseSearch} /> |{' '}
                      </div>
                      <IconButton
                        type="submit"
                        className="ap-icon-button"
                        underline={false}
                        aria-label="search"
                        style={{padding: 0}}
                        onClick={() => {
                          if (isSearching === true && search.length !== 0) {
                            setRealSearch(search)
                          } else {
                            setSearching(true)
                          }
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : (
            <Grid xs={10} style={{position: 'absolute', right: '0px', top: '-1px'}}>
              <Typography style={{position: 'absolute', right: '112px'}}>Values</Typography>
              <IconButton
                type="submit"
                className="ap-icon-button"
                underline={false}
                aria-label="search"
                style={{padding: 0}}
                onClick={() => {
                  if (isSearching === true) {
                    if (search.startsWith('#')) {
                      let newSearch = search.substring(1)
                      setRealSearch(newSearch)
                    } else {
                      setRealSearch(search)
                    }
                  } else {
                    setSearching(true)
                  }
                }}
              >
                <SearchIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
        {(!field.field_id || !field.id) && filterFieldValues.isLoading && (
          <div>
            <div className="please-select-a-field-first">
              <Typography>Please select a field first.</Typography>
            </div>
          </div>
        )}
        {(field.field_id || field.id) && !filterFieldValues.isLoading ? (
          <div style={{margin: '34px 0px'}}>
            <div
              style={{position: 'relative'}}
              // onClick={e => handleSelectAllCheckbox(e)}
            ></div>
            <div className="ap-list__wrapper" style={{margin: '0px -13px', paddingTop: '3px'}}>
              {selectableValues.length > 0 ? (
                selectableValues.map((o, i) => (
                  <div
                    key={i}
                    className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
                `}
                    style={{cursor: 'pointer'}}
                    onClick={e => handleClickValueOption(e, o.value)}
                  >
                    {o.label}
                  </div>
                ))
              ) : (
                <Typography
                  className={`ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
                `}
                >
                  No value
                </Typography>
              )}
            </div>
          </div>
        ) : (
          filterFieldValues.isLoading && (
            <div style={{textAlign: 'center'}}>
              <CircularProgress size={20} />
            </div>
          )
        )}
      </div>
      <div
        className="c-res-mod ap-list ap-scrollbar"
        style={{maxHeight: 200, padding: '17px', width: '200px'}}
      >
        {selectedValues.length > 0 && (
          <div>
            <Grid container>
              <Grid item xs={10}>
                <Typography className="ap-typography--sm">Selected</Typography>
              </Grid>
            </Grid>
          </div>
        )}

        {field && (
          <div className="ap-selected-values">
            {values &&
              normalizedValues.map((o, i) => {
                if (selectedValues.includes(o.value)) {
                  return (
                    <div
                      key={i}
                      className={` ap-typography ap-typography--sm ap-ellipsis`}
                      style={{cursor: 'pointer', color: '#3473ff'}}
                      onClick={e => handleClickValueOption(e, o.value)}
                    >
                      <CheckIcon style={{width: 24, padding: 4, marginRight: 8}} />
                      <span>{o.label}</span>
                    </div>
                  )
                } else return null
              })}
          </div>
        )}
      </div>
    </>
  )
}
